/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Trans, Translation } from 'react-i18next'
import { get } from 'lodash'
import { withRouter } from 'react-router-dom'
import { jsx, css } from '@emotion/react'
import MainLayout from './MainLayout'
import { MobileOnly } from './layout/MobileOnly'
import CallHistoryCard from './CallHistoryCard'
import { Separator } from './layout/Separator'
import { BlueButton } from './layout/BlueButton'
import QuickLinksCard from './QuickLinksCard'
import CreditInformationCard from './CreditInformationCard'
import { Row, Col, Container } from 'react-bootstrap'
import { customerList } from '../actions/customer'
import { UpgradePathNotifications } from './UpgradePathNotifications'

class CallHistory extends Component {

    componentDidMount() {
        const { dispatch } = this.props
        dispatch(customerList.ensureCustomerLoaded())
    }
    
    render() {
        const { customer, history } = this.props
        const active_key = this.props.active_key || "home"
        return (
            <MainLayout active_key={active_key}
                        breadcrumbs={[{name: active_key}]}>
              <Container fluid>

                <UpgradePathNotifications display_style="call_history" />
                
                <Row>
                  <Col md={9}>
                    <CallHistoryCard />
                  </Col>
                  <Col md={3}>
                    <MobileOnly><Separator variant="h20"/></MobileOnly>
                    <Row>
                      <Col>
                        { get(customer, "has_active_fax_out_subscription") &&
                          <>
                            <CreditInformationCard />
                          </>
                        }
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <QuickLinksCard />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <BlueButton extra_css={send_a_fax_button_style}
                                    auto_disable={false} onClick={() => history.push("/send_a_fax")}>
                          <Trans i18nKey="send_a_fax_button">
                            Send a fax
                          </Trans>
                        </BlueButton>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Container>
            </MainLayout>
        )
    }
    
}

function mapStateToProps(state, props) {
    return {
        customer: customerList.getCustomer()
    }
} 

export default withRouter(connect(mapStateToProps)(CallHistory))

const send_a_fax_button_style = css`
width: 100%;
`
